import { styled } from '@mui/material';

import { useSearchParams } from 'react-router';

import { useI18n } from '@app-velocity/i18n';
import { HappyFace } from '@app-velocity/animations';
import { Button, Typography } from '@app-velocity/ui';

const StyledContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(5),
  justifyContent: 'center',
  alignItems: 'center',
}));

const StyledTitle = styled(Typography)({
  fontSize: 48,
  lineHeight: 1,
  fontWeight: 500,
});

export const PaymentSuccess = () => {
  const { t } = useI18n();
  const [searchParams] = useSearchParams();

  const planType = searchParams.get('plan');

  return (
    <StyledContainer>
      <HappyFace />
      <StyledTitle component="h1">
        {t('payments:status.success.title')}
      </StyledTitle>

      <Typography variant="body1">
        {t('payments:status.success.text')}
      </Typography>

      {planType === 'solo' ? (
        <Button variant="contained">
          {t('payments:status.success.go_back_solo')}
        </Button>
      ) : null}
      {planType === 'team' ? (
        <Button variant="contained">
          {t('payments:status.success.set_up_team')}
        </Button>
      ) : null}
      {!planType ? (
        <Typography variant="body1">
          {t('payments:status.can_close')}
        </Typography>
      ) : null}
    </StyledContainer>
  );
};
